module.exports = {
  InsureNo: 'Số đơn bảo hiểm',
  PolicyNo: 'Số hợp đồng bảo hiểm',
  TheInsured: 'Người được bảo hiểm',
  DateOfShipment: 'Ngày khởi hành',
  PlaceOfOrigin: 'Địa điểm khởi hành',
  Destination: 'Điểm đến',
  BillOfLoadingNo: 'Số vận đơn',
  Premium: 'Phí bảo hiểm',
  SubmissionTime: 'Thời gian nộp',
  DeliveryTime: 'Thời gian phát hành đơn',
  DeliveryStatus: 'Trạng thái phát hành đơn',
  Operation: 'Thao tác',
  EditPolicy: 'Chỉnh sửa hợp đồng bảo hiểm',
  DeletePolicy: 'Xóa hợp đồng bảo hiểm',
  DownloadPolicy: 'Tải xuống hợp đồng bảo hiểm',
  CancellationOfPolicy: 'Hủy hợp đồng bảo hiểm',
  ReIssuePolicy: 'Phát hành lại hợp đồng bảo hiểm',
  InvoiceNo: 'Số hóa đơn',
  PlaceOfOriginForSea: 'Cảng khởi hành (đường biển)',
  PlaceOfOriginForAir: 'Cảng khởi hành (đường hàng không)',
  SeaportDestination: 'Cảng đến (đường biển)',
  AirportDestination: 'Cảng đến (đường hàng không)',
  N1CompleteInsuranceInformation: '1. Điền thông tin hợp đồng bảo hiểm',
  N3PreviewAndConfirm: '3. Xem trước và xác nhận',
  Insured: 'Người được bảo hiểm',
  EmailRecipient: 'Người nhận email',
  GoodsCategory: 'Loại hàng hóa',
  GoodsName: 'Tên hàng hóa',
  MarksAndNumbers: 'Ký hiệu hàng hóa',
  BillOfLadingNumber: 'Số vận đơn',
  BillOfLadingDate: 'Ngày vận đơn',
  InvoiceNumber: 'Số hóa đơn',
  ContractNumber: 'Số hợp đồng',
  VesselVoyagevehiclePlateNumberflightNumber: 'Tên tàu/số chuyến/biển số xe/số chuyến bay',
  TransportationType: 'Loại hình vận chuyển',
  Domestic: 'Nội địa',
  Import: 'Nhập khẩu',
  Export: 'Xuất khẩu',
  TransportationMode: 'Phương thức vận chuyển',
  InlandTransportationTools: 'Phương tiện vận chuyển nội địa',
  PlaceOfDepartureport: 'Địa điểm khởi hành (cảng)',
  DepartureDate: 'Ngày khởi hành',
  TransitPlaceport: 'Địa điểm trung chuyển (cảng)',
  Destinationport: 'Điểm đến (cảng)',
  InlandStartingPoint: 'Địa điểm khởi hành nội địa',
  TradeTerms: 'Điều khoản thương mại',
  InvoiceAmount: 'Giá trị hóa đơn',
  MainInsurance: 'Bảo hiểm chính',
  LetterOfCreditConditionNumber: 'Số điều kiện tín dụng',
  ClaimsAgentPoint: 'Đại lý giải quyết bồi thường',
  Insured2: 'Người được bảo hiểm:',
  PolicyHolder: 'Người mua bảo hiểm:',
  EndDateOfInsurance: 'Ngày kết thúc bảo hiểm:',
  DateOfInsurance: 'Ngày mua bảo hiểm:',
  DateOfEntry: 'Ngày nhập liệu:',
  MainClause: 'Điều khoản chính:',
  GoodsName2: 'Tên hàng hóa:',
  InsurancePremium: 'Phí bảo hiểm:',
  InsuranceAmounttotalLimit: 'Số tiền bảo hiểm/Tổng hạn mức:',
  FinalRate: 'Tỷ lệ phí cuối cùng%:',
  AddProportion: 'Tỷ lệ phụ phí%:',
  InsuranceApplicationNumber: 'Số đơn bảo hiểm:',
  PolicyStatus: 'Trạng thái đơn bảo hiểm:',
  InsuranceStartDate: 'Ngày bắt đầu bảo hiểm:',
  ReviewDate: 'Ngày kiểm tra:',
  UnderwritingDate: 'Ngày thẩm định:',
  CompleteInsuranceInformation: 'Điền thông tin đơn bảo hiểm',
  Inquire: 'Yêu cầu báo giá',
  PreviewAndConfirm: 'Xem trước và xác nhận',
  InsuranceCompleted: 'Hoàn tất mua bảo hiểm',
  CancellationReason: 'Lý do hủy',
  PolicyHolderInformation: 'Thông tin người mua bảo hiểm',
  SameAsPolicyHolder: 'Giống người mua bảo hiểm',
  GoodsInformation: 'Thông tin hàng hóa',
  TransportationInformation: 'Thông tin vận chuyển',
  InsuranceAmountInformation: 'Thông tin số tiền bảo hiểm',
  InsuranceConditions: 'Điều kiện bảo hiểm',
  FreightInsurance: 'Bảo hiểm hàng hóa',
  WPA: 'Bảo hiểm rủi ro nước ngập',
  FPA: 'Bảo hiểm rủi ro thông thường',
  AllRiskForRefrigeratedGoods: 'Bảo hiểm mọi rủi ro lạnh',
  RefrigeratedInsurance: 'Bảo hiểm lạnh',
  OtherInformation: 'Thông tin khác',
  InsuranceInstructions: 'Hướng dẫn mua bảo hiểm',
  TheInstitutionsWithTechnicalLtd: 'Các sản phẩm bảo hiểm được liệt kê trên nền tảng này do các tổ chức bảo hiểm cung cấp để bán, và Công ty TNHH Bảo hiểm Cháy Tokyo Marine Nichido (Trung Quốc) cung cấp dịch vụ kỹ thuật.',
  PremiumAmount: 'Số tiền phí bảo hiểm',
  ShanghaiStorageAndTransportationLtd: 'Công ty TNHH Vận tải và Lưu kho Shanghai Jingmao Sankyu',
  SuccessfullyInsured: 'Mua bảo hiểm thành công!',
  PolicyNumber: 'Số đơn bảo hiểm:',
  TemporarySave: 'Tạm lưu',
  PreviewAndContinue: 'Xem trước và tiếp tục',
  Back: 'Quay lại',
  PurchaseInsurance: 'Mua bảo hiểm',
  Submitted: 'Đã gửi',
  SavedSuccessfully: 'Tạm lưu thành công',
  PleaseNameOfTheCompany: 'Vui lòng điền tên doanh nghiệp chủ hàng!',
  PleaseEmailSeparateMultipleSemicolons: 'Vui lòng điền người nhận email! Nhiều người nhận email vui lòng phân cách bằng dấu chấm phẩy tiếng Anh!',
  PleaseGeneralCategoryOfGoods: 'Vui lòng điền loại hàng hóa!',
  PleaseTheNameOfGoods: 'Vui lòng điền tên hàng hóa!',
  PleaseInTheInvoiceNumber: 'Vui lòng điền số hóa đơn',
  TheShippingMarkCannotCharacters: 'Độ dài ký hiệu không được vượt quá 3000 ký tự!',
  TheCannotExceed40Characters: 'Số hóa đơn không được vượt quá 40 ký tự!',
  BillNumberCannotExceedCharacters: 'Số vận đơn không được vượt quá 100 ký tự!',
  ContractCannotExceed100Characters: 'Số hợp đồng không được vượt quá 100 ký tự!',
  PleaseVoyageNumberLicenseNumber: 'Vui lòng nhập tên tàu/chuyến/biển số xe/số chuyến bay',
  PleaseEnterTheTransportationType: 'Vui lòng nhập loại hình vận chuyển',
  PleaseEnterTheTransportationMode: 'Vui lòng nhập phương thức vận chuyển',
  PleasePlaceOfDepartureport: 'Vui lòng nhập nơi khởi hành (cảng)',
  PleaseEnterTheDestinationport: 'Vui lòng nhập nơi đến (cảng)',
  PleaseEnterTheDepartureDate: 'Vui lòng nhập ngày khởi hành',
  PleaseEnterTheTradeTerms: 'Vui lòng nhập điều khoản thương mại!',
  PleaseEnterTheInvoiceAmount: 'Vui lòng nhập số tiền hóa đơn!',
  PleaseEnterTheInvoiceCurrency: 'Vui lòng nhập loại tiền tệ hóa đơn',
  PleaseTheClaimAgencyPoint: 'Vui lòng nhập đại lý bồi thường',
  PleaseAgreeToTheNotice: 'Vui lòng đọc và đồng ý với "Thông báo khách hàng"!',
  PolicyManagement: 'Quản lý đơn bảo hiểm',
  QuickSearchPolicyNumber: 'Tìm kiếm nhanh: Số đơn bảo hiểm',
  Cancellation: 'Hủy bỏ',
  TotalPremium: 'Tổng phí bảo hiểm:',
  PleaseInTheCancellationReason: 'Vui lòng điền lý do hủy bỏ',
  YouPermissionToEditPolicy: 'Bạn không có quyền chỉnh sửa đơn bảo hiểm',
  YouPermissionToDeletePolicy: 'Bạn không có quyền xóa đơn bảo hiểm',
  DeletingThePolicyRecordContinue: 'Sau khi xóa sẽ xóa bỏ hồ sơ đơn bảo hiểm, có tiếp tục không?',
  Confirm: 'Xác nhận',
  InsurancePolicyNumber: 'Số đơn bảo hiểm',
  Deleted: 'Đã xóa',
  YouPermissionToCancelPolicy: 'Bạn không có quyền hủy đơn bảo hiểm',
  PolicyNumber2: 'Số đơn bảo hiểm',
  Canceled: 'Đã hủy',
  YouPermissionToReissuePolicy: 'Bạn không có quyền tái lập đơn bảo hiểm',
  YouBeforeAndCannotAgain: 'Bạn đã tái lập rồi, không được phép tái lập lại!',
  InsuranceInstructionsTip: 'Tôi đã đọc kỹ và đồng ý với "Thông báo khách hàng", "Tuyên bố bảo hiểm", "Thỏa thuận sử dụng nền tảng", "Điều khoản bảo hiểm" và các nội dung khác, hiểu và chấp nhận các thỏa thuận bao gồm điều khoản trách nhiệm, điều khoản miễn trừ, hạn chế loại hàng hóa bảo hiểm, hạn chế giá trị hàng hóa bảo hiểm.',
  InsuranceAgent: 'Đại lý bảo hiểm',
  InsuranceCompany: 'Công ty bảo hiểm',
  InvoiceCurrency: 'Loại tiền hóa đơn',
  InsuranceAmount: 'Số tiền bảo hiểm',
  InsuranceCurrency: 'Loại tiền bảo hiểm',
  PremiumCurrency: 'Loại tiền phí bảo hiểm',
  Rate: 'Tỷ lệ phí',
  Waybillno: 'Số vận đơn (chính)',
  InsureOrderUser: 'Thao tác đơn bảo hiểm',
  PolicyUser: 'Thao tác đơn bảo hiểm',
  ReconciliationUser: 'Thao tác đối chiếu',
  PolicySyncStatus: 'Trạng thái đồng bộ đơn bảo hiểm',
  PremiumSyncStatus: 'Trạng thái đồng bộ phí bảo hiểm',
  StartDate: 'Ngày bắt đầu bảo hiểm',
  EndDate: 'Ngày kết thúc bảo hiểm',
  FreightInsuranceFirstPage: 'Trang chủ bảo hiểm hàng hóa',
  LiabilityInsuranceHomepage: 'Trang chủ bảo hiểm trách nhiệm',
  LiabilityInsurance: 'Bảo hiểm trách nhiệm',
  BillingManagement: 'Quản lý hóa đơn',
  Scanning: 'Tổng quan nhanh',
  Specification: 'Lưu ý đặc biệt',
  ServiceAdvantages: 'Ưu điểm dịch vụ',
  InsuranceType: 'Loại hình bảo hiểm',
  BillQuery: 'Tra cứu hóa đơn',
  InvoiceDownload: 'Tải hóa đơn',
  ViewPolicy: 'Xem đơn bảo hiểm',
  PolicyDownload: 'Tải đơn bảo hiểm',
  AddInquiryQuestionnaire: 'Thêm bảng hỏi báo giá',
  EditOrViewQuestionnaire: 'Chỉnh sửa/Xem bảng hỏi',
  QuestionnaireStatus: 'Trạng thái bảng hỏi',
  PolicyStatus2: 'Trạng thái đơn bảo hiểm',
  LiabilityInsuranceInquiry: 'Báo giá bảo hiểm trách nhiệm đại lý vận chuyển',
  InquiryForQuestionnaireContent: '*Nội dung bảng hỏi này chỉ dùng cho báo giá bảo hiểm trách nhiệm, Wohang và công ty thứ ba sẽ bảo mật nghiêm ngặt;',
  AfterFillingQuestionnaire: '*Sau khi điền bảng hỏi, bên thứ ba sẽ liên hệ số điện thoại lưu lại trong vòng 24 giờ;',
  ServiceProviderSelection: 'Lựa chọn nhà cung cấp:',
  ApplicantInformation: 'Thông tin người yêu cầu:',
  RegisteredAndBusiness: 'Tên đăng ký và tên kinh doanh của công ty (nếu có):',
  InquiryQuestionnaire: 'Bảng hỏi báo giá',
  ServiceProviderReply: 'Phản hồi từ nhà cung cấp',
  ServiceProviderReply2: 'Phản hồi từ nhà cung cấp',
  RegisteredName: 'Tên đăng ký',
  RegisteredAddress: 'Địa chỉ đăng ký',
  BusinessName: 'Tên kinh doanh',
  BusinessAddress: 'Địa chỉ kinh doanh',
  RecoveryTime: 'Thời gian phản hồi:',
  ReplyContent: 'Nội dung phản hồi:',
  ExistInsuranceReocordContinue: 'Vận đơn hiện tại đã có hồ sơ bảo hiểm, có tiếp tục không?',
  TheInsuranceHasExist: 'Bảo hiểm không thể lặp lại',
  CreatedNewInsureForm: 'Tạo đơn bảo hiểm mới',
  ToViewOriginalApplication: 'Xem đơn bảo hiểm cũ, vui lòng truy cập',
  Insurance: 'Bảo hiểm',
  Tab: 'Tab',
  EditViewInsuranceForm: 'Chỉnh sửa/Xem đơn bảo hiểm',
  Deductible: 'Mức miễn thường',
  InsuranceCoverage: 'Phạm vi bảo hiểm',
  SpecialInstructions: 'Ghi chú đặc biệt',
  ClaimsService: 'Dịch vụ bồi thường',
  ServiceProviderIntroduction: 'Giới thiệu nhà cung cấp',
  SpecialCargo: 'Hàng hóa đặc biệt',
  CargoExclusion: 'Hàng hóa loại trừ',
  SpecialAgreement: 'Thỏa thuận đặc biệt',
  ChooseServiceProvider: 'Chọn nhà cung cấp',
  ViewInsurancePolicy: 'Xem đơn bảo hiểm trên trang bảo hiểm',
  RememberOperationDirectly: 'Ghi nhớ thao tác này, lần sau bảo hiểm trực tiếp',
  ProductValue: 'Giá trị sản phẩm',
  Charges: 'Biểu phí',
  MaximumIndemnityNorm: 'Giới hạn bồi thường',
  SupplierResponse: 'Phản hồi từ nhà cung cấp',
  UploadedFileUnRemove: 'Không được phép xóa tệp đã tải lên!',
  NoCorrespondingTemplate: 'Không tìm thấy mẫu tương ứng!',
  NotAllowDeleteSubmited: 'Hồ sơ bảo hiểm đã được gửi và phát hành không được phép xóa, vui lòng chọn lại!',
  OnlyFileDocAndPdf: 'Chỉ được phép tải lên các tệp có đuôi là [doc, docx, pdf], vui lòng chọn lại!',
  ToInsure: 'Bảo hiểm:',
  FillInsuranceInformation: 'Điền thông tin bảo hiểm',
  ClickToDownloadTemplate: 'Nhấp để tải mẫu và điền theo định dạng',
  DragFile: 'Kéo tệp vào đây hoặc',
  ClickToUpload: 'Nhấp để tải lên'
}
